/** BENQI sAVAX — paginated unlock-requests enumeration.
 *  Address on chain 43114: `0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be`. */
export const BenqiSavaxWithdrawalAbi = [
  {
    name: 'getUnlockRequestCount',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getPaginatedUnlockRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'from' },
      { type: 'uint256', name: 'to' },
    ],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint256', name: 'startedAt' },
          { type: 'uint256', name: 'shareAmount' },
        ],
      },
    ],
  },
  {
    name: 'cooldownPeriod',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'redeemPeriod',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
